import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { ProductVariationPage } from './product-variation';

@NgModule({
  declarations: [
    ProductVariationPage,
  ],
  imports: [
    IonicPageModule.forChild(ProductVariationPage),
  ],
  exports: [
    ProductVariationPage
  ]
})
export class ProductVariationModule {}



// WEBPACK FOOTER //
// ./src/pages/product-variation/product-variation.module.ts